import styled from 'styled-components';

export const HomepageHeaderContainer = styled.div`
    position: relative;
    overflow: hidden;
    z-index: 4;
    padding-bottom: 100px;
    margin-bottom: 100px;
    background: #0f1129;

    &:after {
        z-index: 8;
        content: '';
        position: absolute;
        height: 200px;
        width: 100%;
        bottom: 0;
        background: linear-gradient(0deg, #0f1129 0%, rgba(0, 0, 0, 0) 100%);
        left: 0;
    }

    .timeline-hide,
    .timeline-wrapper.toggle {
        opacity: 1;
        pointer-events: none;
    }

    .timeline-show {
        background: #0f1129;
    }

    &:not(.inView) {
        #universe {
            opacity: 0;
        }
    }

    .scalebox {
        height: 85vh;
        position: absolute;
        top: 0;
        width: 80vw;
        max-width: 1300px;
        left: 0;
        right: 0;
        bottom: 0;
        margin-left: auto;
        margin-right: auto;
        text-align: center;
        z-index: 4;
    }

    &.toggling {
        a,
        .scalebox {
            pointer-events: none;
            display: none;
        }
    }
`;

export const HomepageHeaderWrapper = styled.div`
    position: relative;
    overflow: visible;
`;

export const HomepageWrapper = styled.div`
    width: 100%;
    height: 100vh;
    margin: 0 auto;
    position: relative;
    background: #0f1129;
    pointer-events: none;

    &:before {
        z-index: 8;
        content: '';
        position: absolute;
        height: 200px;
        width: 100%;
        top: 0;
        background: linear-gradient(180deg, #0f1129 0%, rgba(0, 0, 0, 0) 100%);
        left: 0;
    }

    .content {
        position: absolute;
        bottom: 200px;
        left: 0;
        right: 0;
        z-index: 3;
        opacity: 0;
        transform: translateY(50px);
        transition: 0.8s ease;
        width: 100%;
        max-width: 1456px;
        margin: 0 auto;
        pointer-events: none;
        vertical-align: top;
        text-shadow: 1px 0px 10px rgba(15, 17, 41, 0.2);

        h2,
        .paragraph,
        .ue-rich-text {
            vertical-align: top;
        }

        h2 {
            float: left;
        }

        .paragraph {
            float: right;
        }

        .MuiGrid-item {
            min-height: 100px;
        }
    }

    &.loaded {
        .content {
            opacity: 1;
            transform: translateY(0px);
        }
    }
    &.toggle.loaded {
        .content {
            opacity: 0;
            transform: translateY(-50px);
        }
        #mainVideo {
            opacity: 0;
        }
    }

    .video-container {
        background: none;
    }

    video,
    .html-video-embed,
    .screen,
    #mainVideo,
    #intro,
    #universe {
        max-width: 1920px;
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        pointer-events: none;
        margin: auto;
        outline: none;
        transition: 0.2s ease;
    }

    #mainVideo,
    #intro {
        &:before,
        &:after {
            z-index: 8;
            content: '';
            position: absolute;
            height: 100%;
            width: 300px;
            top: 0;
        }
        &:before {
            background: linear-gradient(90deg, #0f1129 0%, rgba(0, 0, 0, 0) 100%);
            left: 0;
        }
        &:after {
            background: linear-gradient(270deg, #0f1129 0%, rgba(0, 0, 0, 0) 100%);
            right: 0;
        }
    }

    #intro,
    #universe {
        @media screen and (min-width: 1920px) {
            &:before,
            &:after {
                z-index: 8;
                content: '';
                position: absolute;
                height: 100%;
                width: 300px;
                top: 0;
            }
            &:before {
                background: linear-gradient(90deg, #0f1129 0%, rgba(0, 0, 0, 0) 100%);
                left: 0;
            }
            &:after {
                background: linear-gradient(270deg, #0f1129 0%, rgba(0, 0, 0, 0) 100%);
                right: 0;
            }
        }
    }

    #mainVideo {
        z-index: 2;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        transition: 0.2s ease;
        .video-wrapper {
            &:after {
                z-index: 8;
                content: '';
                position: absolute;
                height: 800px;
                width: 100%;
                bottom: 0;
                background: linear-gradient(0deg, #0f1129 0%, rgba(0, 0, 0, 0) 100%);
                left: 0;
            }
        }
        video {
            width: 100vw;
            height: auto;
            z-index: 2;
            display: block;
            opacity: 1;
            object-fit: cover;
            background: none;
        }
        video {
            transform: scale(1);
            object-fit: contain;
        }
        .video.background-video {
            background: none !important;
        }

        &.hide {
            opacity: 0;
        }

        &.scale-up {
            &:not(.playing-main):not(.not-inView) {
                transform: scale(1.1);
                ${(p) => p.theme.breakpoints.down('lg')} {
                    transform: scale(1.2);
                }
            }
        }
    }

    #intro {
        z-index: 4;
        opacity: 0;

        &.show {
            opacity: 1;
        }

        video {
            width: 100vw;
            height: auto;
            z-index: 2;
            display: block;
            opacity: 1;
            object-fit: cover;
            background: none;
        }
    }

    #universe {
        z-index: 1;
        opacity: 0;
        pointer-events: none;
        max-width: 1920px;
        width: 100vw;
        margin: 0 auto;
        &.show {
            opacity: 1;
        }
        video.universe-video {
            opacity: 0;
            width: 100vw;
            z-index: 2;
            &.active {
                display: block;
                opacity: 1;
            }
        }
    }
`;
